import * as errors from './index';

const authErrorResolve = errorCode => {
  let instanceError;
  Object.values(errors).forEach(error => {
    if (error.code === errorCode) {
      instanceError = error;
    }
  });

  return instanceError || errors.DefaultError;
};

export default authErrorResolve;
